import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import CustomerVerification from "./page/customerVerification";
import ErrorTechnical from "./page/errorEechnical";

const CommonRoute = () => (
    <Router basename="/common">
        <Switch>
            <Redirect exact from="/" to="/customer-verification" />
            <Route
                exact
                path="/customer-verification"
                component={CustomerVerification}
            />
            <Route exact path="/error" component={ErrorTechnical} />
            <Route exact>
                <h1>404 not Found</h1>
            </Route>
        </Switch>
    </Router>
);

export default CommonRoute;
